import { concat, every, has, isEmpty, merge, reduce } from 'lodash';
function buildOptions() {
  let {
    options = [],
    selected = [],
    disableParent = true,
    level = 0,
    removeDisabled = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Remove disabled parents and children if needed
  const filteredOptions = removeDisabled ? options.reduce((acc, curr) => {
    const children = (curr.children || []).filter(child => !child.selectionDisabled);
    const isParentDisabled = curr.selectionDisabled;
    const hasChildren = children.length > 0;
    if (!isParentDisabled || hasChildren) {
      acc.push({
        ...curr,
        children: hasChildren ? children : undefined
      });
    }
    return acc;
  }, []) : options;
  return reduce(filteredOptions, (acc, opt) => {
    if (has(opt, 'children') && !isEmpty(opt.children)) {
      const allChildrenSelected = every(reduce(opt.children, (arr, child) => {
        if (selected.includes(child.value)) {
          return [...arr, true];
        }
        return [...arr, false];
      }, []));
      const newOpt = merge(opt, {
        hasChildren: true,
        level,
        disabled: disableParent,
        allChildrenSelected
      });
      return concat(acc, newOpt, buildOptions({
        options: opt.children,
        selected,
        disableParent,
        level: level + 1,
        removeDisabled
      }));
    }
    return concat(acc, merge(opt, {
      hasChildren: false,
      level
    }));
  }, []);
}
export default buildOptions;
//# sourceMappingURL=buildOptions.js.map